export default "/assets/images/mila-valentine-black-white.6ced97b375805fa9.webp";